import Icon from '@atoms/Icon/Icon';
import { ITechnicalSpecificationItem } from '@models/ITechnicalSpecificationItem';
import truncateText from '@utils/helpers/truncateText';
import useMediaQuery from '@utils/hooks/useMediaQuery';
import { useState } from 'react';

interface Props extends ITechnicalSpecificationItem {
  readonly dataTestId?: string;
  readonly showIcons?: boolean;
  readonly readMoreLabel: string;
  readonly readLessLabel: string;
}

const TechnicalSpecificationItem = ({
  dataTestId = 'Technical-Specification-Item',
  title,
  icon,
  text,
  readMoreLabel,
  readLessLabel,
  showIcons,
}: Props) => {
  const [readMore, setReadMore] = useState(false);
  const isMobile = useMediaQuery(400);

  return (
    <div
      className="grid grid-flow-col grid-cols-5 gap-5 border-grey-500/40 border-b border-solid py-5 first:border-t xl:grid-cols-12 xl:gap-4 xl:py-10"
      data-testid={dataTestId}
    >
      {showIcons && icon && (
        <div className="col-start-1 col-end-2">
          <div className="w-6 xl:w-12">
            <Icon
              name={icon}
              size="100%"
              colorClassName="dark:text-white"
              data-testid={`${dataTestId}-Icon`}
            />
          </div>
        </div>
      )}
      {(title || text) && (
        <div className="col-span-4 grid grid-flow-row items-center xl:col-span-12 xl:grid-flow-col xl:grid-cols-12 xl:gap-4">
          {title && (
            <span
              dangerouslySetInnerHTML={{ __html: title }}
              className="h6 pb-2 xl:col-span-3 dark:text-white"
              data-testid={`${dataTestId}-Title`}
            />
          )}
          {text && (
            <span
              dangerouslySetInnerHTML={{
                __html:
                  text.length > 165 && isMobile && !readMore
                    ? truncateText(text, 165, ' ')
                    : text,
              }}
              className="body-one col-span-9 text-grey-600 dark:text-grey-500"
              data-testid={`${dataTestId}-Text`}
            />
          )}

          {text && text.length > 165 && isMobile && (
            <button
              onClick={() => setReadMore(!readMore)}
              className="w-full cursor-pointer text-left text-black-100 underline dark:text-grey-200"
              aria-hidden="true"
              data-testid={`${dataTestId}-Read-More`}
            >
              {readMore ? readLessLabel : readMoreLabel}
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default TechnicalSpecificationItem;
